interface IGtmWindow {
  dataLayer?: Record<string, unknown>[];
}

export function getDataLayer(): Record<string, unknown>[] | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const w = window as Window & IGtmWindow;
  if (!w.dataLayer) {
    w.dataLayer = [];
  }
  return w.dataLayer;
}
